import { createTranslations } from '@npco/utils-translations'

export const outstandingExpensesToggleTranslations = createTranslations({
  badgeText: 'Outstanding Expenses',
  badgeTextMobile: 'Outstanding',
  tooltipContentAdmin:
    'Go to Settings under the Corporate Cards tab to enable Outstanding Expenses.',
  tooltipContentManager: "You don't have any expenses to reconcile.",
})
